/**
 * @generated SignedSource<<2eb5752aa12d197e800601e91a441a8f>>
 * @relayHash b324e51b14bf37120851a6b50d917a00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0178641a60d9c78675fa1cb5da90709044fd8859b363ec10502ff5b356241e37

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StakeholderCommsPageStatus = "DRAFT" | "PUBLISHED" | "PUBLISHED_WITH_CHANGES" | "SOFT_DELETED" | "UNPUBLISHED" | "UNPUBLISHED_WITH_CHANGES" | "%future added value";
export type StatuspageDetailsPageQuery$variables = {
  cloudId?: string | null;
  pageId: string;
};
export type StatuspageDetailsPageQuery$data = {
  readonly stakeholderComms_getPageById: {
    readonly error: string | null;
    readonly page: {
      readonly id: string;
      readonly pageStatus: StakeholderCommsPageStatus | null;
      readonly " $fragmentSpreads": FragmentRefs<"StatuspageDetailsPageContent_stakeholderCommsPage">;
    } | null;
  } | null;
};
export type StatuspageDetailsPageQuery = {
  response: StatuspageDetailsPageQuery$data;
  variables: StatuspageDetailsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "pageId",
    "variableName": "pageId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "error"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "pageStatus"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StatuspageDetailsPageQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "StakeholderCommsPageResponse",
        "kind": "LinkedField",
        "name": "stakeholderComms_getPageById",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "concreteType": "StakeholderCommsPage",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "StatuspageDetailsPageContent_stakeholderCommsPage"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StatuspageDetailsPageQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "StakeholderCommsPageResponse",
        "kind": "LinkedField",
        "name": "stakeholderComms_getPageById",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "concreteType": "StakeholderCommsPage",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "pageType"
              },
              {
                "concreteType": "StakeholderCommsCustomDomainConfig",
                "kind": "LinkedField",
                "name": "customDomainConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "domain"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "sslStatus"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "domainStatus"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "version"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "subdomain"
              },
              {
                "kind": "ScalarField",
                "name": "timezone"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0178641a60d9c78675fa1cb5da90709044fd8859b363ec10502ff5b356241e37",
    "metadata": {},
    "name": "StatuspageDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3bdf1bd54425335bc7aa6d063f506c67";

export default node;
